module.exports = __webpack_public_path__ + "img/gpay.1c25aaa0.svg";